import initialState from '../store/initialstate';
import C from '../constants/alert';

export default (state = initialState().alert, action = null) => {
    switch(action.type){
        case C.SET_ALERT:
            return state.set(C.ALERT_PROPS, action.payload);

        case C.ALERT_ACTIVE:
            return state.set(C.ALERT_ACTIVE, action.payload);
            // return state.updateIn([C.ALERT_PROPS, C.ALERT_ACTIVE], ()=>action.payload);


        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./reducers/alert.js